import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const filterButtonIconContainerStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	gap: 'space.075',
});

export const FilterButtonIconContainer = ({ children }: React.PropsWithChildren<{}>) => {
	return <Box xcss={filterButtonIconContainerStyles}>{children}</Box>;
};
